import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "UserGroup2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.75 6.75C12.75 4.67893 11.0711 3 9 3C6.92893 3 5.25 4.67893 5.25 6.75C5.25 8.82107 6.92893 10.5 9 10.5C11.0711 10.5 12.75 8.82107 12.75 6.75ZM3.75 6.75C3.75 3.85051 6.1005 1.5 9 1.5C11.8995 1.5 14.25 3.85051 14.25 6.75C14.25 9.6495 11.8995 12 9 12C6.1005 12 3.75 9.6495 3.75 6.75ZM15 22.5H16.5V18.75C16.5 15.8505 14.1495 13.5 11.25 13.5H6.75C3.85051 13.5 1.5 15.8505 1.5 18.75V22.5H3V18.75C3 16.6789 4.67893 15 6.75 15H11.25C12.2446 15 13.1984 15.3951 13.9017 16.0983C14.6049 16.8016 15 17.7554 15 18.75V22.5ZM14.4676 11.9733L14.4088 11.9457C14.836 11.501 15.209 11.0038 15.517 10.4647C17.3434 10.2128 18.75 8.64568 18.75 6.75C18.75 4.85432 17.3434 3.28717 15.5169 3.03534C15.2045 2.4884 14.8252 1.98459 14.3902 1.53504C14.5903 1.51189 14.7937 1.5 15 1.5C17.8995 1.5 20.25 3.85051 20.25 6.75C20.25 9.6495 17.8995 12 15 12C14.8203 12 14.6427 11.991 14.4676 11.9733ZM19.9016 16.0983C19.3214 15.5181 18.5707 15.1477 17.7672 15.0358C17.4466 14.4744 17.0555 13.9585 16.6061 13.5H17.25C20.1495 13.5 22.5 15.8505 22.5 18.75V22.5H21V18.75C21 17.7554 20.6049 16.8016 19.9016 16.0983Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/UserGroup2.vue"]]);
